import { NgModule } from '@angular/core';
import { ProgressBarComponent } from './components/progress-bar.component';

@NgModule({
  exports: [ProgressBarComponent],
  imports: [ProgressBarComponent],
})
export class ProgressBarModule {}
